import axios from 'axios';
import {getField, updateField} from 'vuex-map-fields';

const getDefaultState = () => {
    return {
        treeComponentKey: 0,
        roles: {
            items: [],
            from: 0,
            to: 0,
            total: 0
        },
        role: {
            id: null,
            name: null,
            permissions: null,
            relationships: {
                permissions: [],
            }
        },
        all: [],
        modules: []
    }
}

export const state = getDefaultState();

export const getters = {
    all: (state) => state.all,
    getField
}

export const actions = {
    async fetchRoles({commit}, pagination) {
        const response = await axios.post(`roles/paginate?page=${pagination.currentPage}`, {...pagination});
        commit('SET_ROLES', response.data)
    },
    async store({commit, state}) {
        await axios.post(`roles`, state.role);
        commit('RESET_ROLE');
    },
    async update({commit, state}) {
        await axios.put(`roles`, state.role);
        commit('RESET_ROLE');
    },
    async fetchById({commit}, id) {
        const response = await axios.get(`roles/${id}/edit`);
        commit('SET_ROLE', response.data);
    },
    /*eslint no-unused-vars: ["error", { "args": "none" }]*/
    async delete({commit}, id) {
        await axios.delete(`roles/${id}`);
    },
    async all({commit}) {
        const response = await axios.get(`roles/all`);
        commit('SET_ALL', response.data);
    },
    async allPermissionsModules({commit}) {
        const response = await axios.get(`roles/permissions/modules`);
        commit('SET_ALL_PERMISSIONS_MODULES', response.data);
    },
    resetRole({commit}){
        commit('RESET_ROLE');
    }
}

export const mutations = {
    updateField,
    SET_ROLES(state, roles) {
        state.roles = {
            items: roles.data,
            from: roles.meta.from,
            to: roles.meta.to,
            total: roles.meta.total
        }
    },
    SET_ROLE(state, role) {
        state.role = role.data;
    },
    RESET_ROLE(state) {
        Object.assign(state.role, getDefaultState().role)
    },
    SET_ALL: (state, roles) => {
        state.all = roles
    },
    SET_ALL_PERMISSIONS_MODULES(state, permissionsModules) {
        state.modules = permissionsModules.data
        state.treeComponentKey += 1;
    }
}